/* istanbul ignore file: Directive */
'use strict';


/**
 * Check if an iccid is valid.
 *
 * Set it to the iins you which to allow.  Omit the value to allow only JIM sims.  Set it to 'full' to only
 * allow full ICCIDs.
 */
customerZone.directive('validateIccid', ['utils', function (utils) {
    return {
        require: 'ngModel',
        link: function (scope, elem, attrs, ctrl) {
            ctrl.$parsers.push(function(value){
                var setting = attrs['validateIccid'];
                if (!setting || setting === '') setting = 'JIM';
                else setting = scope.$eval(setting);
                if (setting === 'full') setting = undefined;

                if (Array.isArray(setting) && setting.length === 0){
                    // if we don't know the operator IINs, we only do a length check.
                    return value && value.length >= 13 ? value : undefined;
                }

                if (value === '') return '';
                else {
                    var valid = utils.checkIccid(value, setting);
                    if (!valid.valid) return undefined;
                    return value;
                }
            });
        }
    };
}]);
